import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Manage Incidents</h3>
                <p className="text-sm text-gray-600">
                    Track and manage vehicle incidents, accidents, or infractions.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Recording Incidents</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Click <strong>Add Incident</strong> to report a new event.</li>
                    <li>Specify details like <strong>Time</strong>, <strong>Vehicle</strong>, <strong>Type</strong>, <strong>Status</strong>, and <strong>Location</strong>.</li>
                    <li>You can also assign a <strong>Causer</strong> (Driver) if applicable.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Filtering and Searching</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Use the <strong>Date Range Picker</strong> to view incidents within a specific period.</li>
                    <li>Use the <strong>Search Bar</strong> to find incidents by ID, vehicle name, or other keywords.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Export Options</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Select rows to export specific incident records.</li>
                    <li>Download reports in <strong>PDF</strong> or <strong>CSV</strong> format for offline analysis.</li>
                </ul>
            </section>
        </div>
    );
};

export default Help;
